import type { ShoppingItem } from '@homeapp/shared';

interface Props {
  item: ShoppingItem;
  onToggle: () => void;
  onDelete: () => void;
}

const CATEGORY_ICONS: Record<string, string> = {
  Food: '🍎',
  Household: '🏠',
  Cat: '🐱',
  Hygiene: '🧴',
  Other: '📦',
};

function formatDate(iso: string) {
  const d = new Date(iso);
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
}

export default function ShoppingItemRow({ item, onToggle, onDelete }: Props) {
  const isBought = item.status === 'bought';

  return (
    <div
      className={`flex items-center gap-3 p-3 rounded-xl transition-all ${
        isBought ? 'bg-gray-100 opacity-60' : 'bg-white shadow-sm'
      }`}
    >
      {/* Checkbox */}
      <button
        onClick={onToggle}
        className={`w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition ${
          isBought
            ? 'bg-green-500 border-green-500 text-white'
            : 'border-gray-300 hover:border-blue-400'
        }`}
      >
        {isBought && <span className="text-xs">✓</span>}
      </button>

      {/* Content */}
      <div className="flex-1 min-w-0">
        <div className={`font-medium ${isBought ? 'line-through text-gray-400' : 'text-gray-800'}`}>
          {item.name}
        </div>
        <div className="flex items-center gap-2 text-xs text-gray-400">
          <span>{CATEGORY_ICONS[item.category] || '📦'} {item.category}</span>
          <span>·</span>
          <span>{formatDate(item.addedAt)}</span>
          {isBought && item.boughtAt && (
            <>
              <span>·</span>
              <span>✓ {formatDate(item.boughtAt)}</span>
            </>
          )}
        </div>
      </div>

      {/* Delete */}
      <button
        onClick={onDelete}
        className="text-gray-300 hover:text-red-500 transition p-1"
        title="Delete"
      >
        ✕
      </button>
    </div>
  );
}
